export const BUSINESS = {
    name: "EG Wireless",
    phone: "(818) 548-9999",
    phoneRaw: "+18185489999",
    address: "1105 S Glendale Ave, Glendale, CA 91205",
    locatedInside: "7-Eleven Plaza",
    rating: 4.8,
    reviewCount: 19,
    mapsEmbed:
        "https://www.google.com/maps?q=1105+S+Glendale+Ave,+Glendale,+CA+91205&output=embed",
    mapsDirections:
        "https://www.google.com/maps/dir/?api=1&destination=1105+S+Glendale+Ave,+Glendale,+CA+91205",
};

export const CATEGORIES = [
    { id: "all", label: "All Products" },
    { id: "smartphones", label: "Smartphones" },
    { id: "cases", label: "Cases" },
    { id: "chargers", label: "Chargers" },
    { id: "screen-protectors", label: "Screen Protectors" },
    { id: "sim-cards", label: "SIM Cards" },
    { id: "accessories", label: "Accessories" },
];

export const FAQS = [
    { q: "Do you sell new smartphones?", a: "Yes. We carry the latest iPhone, Samsung Galaxy, Google Pixel and more — both unlocked and carrier-locked. Walk in or call to check current stock." },
    { q: "Can you activate my phone?", a: "Absolutely. We activate phones on AT&T, T-Mobile, Verizon, Cricket, Boost, Metro and most prepaid carriers — typically in under 10 minutes." },
    { q: "Do you carry accessories?", a: "We stock cases, chargers, screen protectors, earbuds, cables, MagSafe products and more from premium brands like OtterBox, Anker, Spigen, Belkin and Apple." },
    { q: "Do you offer technical support?", a: "Yes. Walk-in technical support is free for diagnostics. We help with data transfer, app setup, email configuration and general troubleshooting." },
    { q: "Can you transfer my data?", a: "We transfer contacts, photos, messages and apps between Android and iPhone devices — usually in 15–30 minutes." },
    { q: "Where are you located?", a: "1105 S Glendale Ave, Glendale, CA 91205 — inside the 7-Eleven Plaza. We have plenty of free parking." },
    { q: "Can you help choose a wireless plan?", a: "Yes. We compare AT&T, T-Mobile, Verizon and prepaid options to match you with the right plan based on data usage, family lines and budget — completely unbiased." },
];
